import { Pagination, PaginationItem, PaginationLink, Table } from 'reactstrap'
import { useContext } from 'react'
import { TanstackContext } from './TanstackContext'

const TanstackPaginator = () => {
  const { table } = useContext(TanstackContext)

  const pages = table.getPageCount()
  const state = table.getState()
  const { pagination } = state
  const { pageIndex, pageSize } = pagination

  const marge = 10

  if (pageSize <= 0) return null

  return (
    <div className="d-flex justify-content-center">
      <Pagination size="md">
        <PaginationItem disabled={!table.getCanPreviousPage()}>
          <PaginationLink first onClick={() => table.setPageIndex(0)} />
        </PaginationItem>

        <PaginationItem disabled={!table.getCanPreviousPage()}>
          <PaginationLink previous onClick={() => table.previousPage()} />
        </PaginationItem>

        {Array.from({ length: marge }, (_, i) => {
          const p = pageIndex - i
          return p <= 0 ? null : (
            <PaginationItem key={p}>
              <PaginationLink onClick={() => table.setPageIndex(p - 1)}>{p}</PaginationLink>
            </PaginationItem>
          )
        }).reverse()}

        {pages <= 0 ? null : (
          <PaginationItem active>
            <PaginationLink>{pageIndex + 1}</PaginationLink>
          </PaginationItem>
        )}

        {Array.from({ length: marge }, (_, i) => {
          const p = pageIndex + 1 + i
          return p > pages - 1 ? null : (
            <PaginationItem key={p}>
              <PaginationLink onClick={() => table.setPageIndex(p)}>{p + 1}</PaginationLink>
            </PaginationItem>
          )
        })}

        <PaginationItem disabled={!table.getCanNextPage()}>
          <PaginationLink next onClick={() => table.nextPage()} />
        </PaginationItem>

        <PaginationItem disabled={!table.getCanNextPage()}>
          <PaginationLink last onClick={() => table.setPageIndex(table.getPageCount() - 1)} />
        </PaginationItem>
      </Pagination>
    </div>
  )
}

export default TanstackPaginator
